import React, {useState} from 'react';

import './SideMenu.css';
import {SideMenuSection} from "./side-menu-section/SideMenuSection";

export const SideMenu = ({showMenu, navigateTo, context, setContext}) => {

    const dashboardMenuLinks = [
        {name: "Profile", screenKey: "dashboardProfile"},
        {name: "Account", screenKey: "dashboardAccount"},
    ];

    const problemsMenuLinks = [
        {name: "Search Problems", screenKey: "problemSearch"},
        {name: "New Problem", screenKey: "facilitySelect"},
        {name: "My Problems", screenKey: "myProblems"},
    ];

    const trainingMenuLinks = [
        {name: "Search Training", screenKey: "trainingSearch"},
        {name: "New Training", screenKey: "trainingCapture"},
        {name: "Training Groups", screenKey: "trainingGroupSearch"},
    ]

    const changePackageMenuLinks = [
        {name: "Search Change Packages", screenKey: "changePackageSearch"},
        {name: "New Change Package", screenKey: "changePackageView"},
    ]

    const reportsMenuLinks = [
        {name: "Facility Report", screenKey: "facilityReport"},
        {name: "Change Idea Report", screenKey: "changeIdeaReport"},
        {name: "Staff Member Report", screenKey: "staffMemberReport"},
        {name: "Training Report", screenKey: "trainingReport"},
        {name: "A3 Report", screenKey: "problemSearch"},
        {name: "HSD Report", screenKey: "hsdReport"},
        {name: "Gates Report", screenKey: "gatesPerspectiveTable"},
    ];

    const adminMenuLinks = [
        {name: "Staff Members", screenKey: "staffMemberTable"},
        {name: "Grants", screenKey: "grantTable"},
        {name: "Topic Areas", screenKey: "topicAreaTable"},
        {name: "Indicators", screenKey: "indicatorTable"},
        {name: "Change Concepts", screenKey: "changeConceptTable"},
        {name: "Training Topics", screenKey: "trainingTopicTable"},
        {name: "Locations", screenKey: "facilityTable"},
    ];

    const roles = context.roles;
    let isAdmin;
    let reportAccess;
    if (null !== roles) {
        isAdmin = roles.includes("qi-admin");
        reportAccess = roles.includes("qi-report-access");
    }

    const [dashboardClosed, setDashboardClosed] = useState(true);
    const [problemsClosed, setProblemsClosed] = useState(true);
    const [trainingClosed, setTrainingClosed] = useState(true);
    const [changePackagesClosed, setChangePackagesClosed] = useState(true);
    const [reportsClosed, setReportsClosed] = useState(true);
    const [adminClosed, setAdminClosed] = useState(true);

    const toggleClosed = (title) => {
        switch (title) {
            case "Dashboard":
                setDashboardClosed(!dashboardClosed);
                setProblemsClosed(true);
                setTrainingClosed(true);
                setChangePackagesClosed(true);
                setReportsClosed(true);
                setAdminClosed(true);
                break;
            case "Problems":
                setDashboardClosed(true);
                setProblemsClosed(!problemsClosed);
                setTrainingClosed(true);
                setChangePackagesClosed(true);
                setReportsClosed(true);
                setAdminClosed(true);
                break;
            case "Training":
                setDashboardClosed(true);
                setProblemsClosed(true);
                setTrainingClosed(!trainingClosed);
                setChangePackagesClosed(true);
                setReportsClosed(true);
                setAdminClosed(true);
                break;
            case "Change Packages":
                setDashboardClosed(true);
                setProblemsClosed(true);
                setTrainingClosed(true);
                setChangePackagesClosed(!changePackagesClosed);
                setReportsClosed(true);
                setAdminClosed(true);
                break;
            case "Reports":
                setDashboardClosed(true);
                setProblemsClosed(true);
                setTrainingClosed(true);
                setChangePackagesClosed(true);
                setReportsClosed(!reportsClosed);
                setAdminClosed(true);
                break;
            default:
                setDashboardClosed(true);
                setProblemsClosed(true);
                setTrainingClosed(true);
                setChangePackagesClosed(true);
                setReportsClosed(true);
                setAdminClosed(!adminClosed);
                break;
        }
    }

    return (
        <div className={"side-menu-container " + (!showMenu ? "hidden" : null)}>
            <SideMenuSection title="Dashboard" links={dashboardMenuLinks} activeSection={context.activeSection}
                             closed={dashboardClosed} toggleClosed={toggleClosed} navigateTo={navigateTo}
                             setContext={setContext}/>
            <SideMenuSection title="Problems" links={problemsMenuLinks} activeSection={context.activeSection}
                             closed={problemsClosed} toggleClosed={toggleClosed} navigateTo={navigateTo}
                             setContext={setContext}/>
            <SideMenuSection title="Training" links={trainingMenuLinks} activeSection={context.activeSection}
                             closed={trainingClosed} toggleClosed={toggleClosed} navigateTo={navigateTo}
                             setContext={setContext}/>
            <SideMenuSection title="Change Packages" links={changePackageMenuLinks} activeSection={context.activeSection}
                             closed={changePackagesClosed} toggleClosed={toggleClosed} navigateTo={navigateTo}
                             setContext={setContext}/>
            {(reportAccess || isAdmin) &&
            <SideMenuSection title="Reports" links={reportsMenuLinks} activeSection={context.activeSection}
                             closed={reportsClosed} toggleClosed={toggleClosed} navigateTo={navigateTo}
                             setContext={setContext}/>}
            {isAdmin &&
            <SideMenuSection title="Admin" links={adminMenuLinks} activeSection={context.activeSection}
                             closed={adminClosed} toggleClosed={toggleClosed} navigateTo={navigateTo}
                             setContext={setContext}/>}
        </div>
    );
}
